import React, { useCallback, useEffect, useState } from "react";
import EmailsHistory from "../../../../Common/AutoSuggestion/Email-History-Page/EmailsHistory";
import mailIcon from "../../../../Assets/Images/client-email-icon.svg";
import { post } from "../../../../helper/Api_helper.js";
import {
  VYLABS_BASE_URL,
  EMAIL_HISTORY_CLIENT,
} from "../../../../helper/url_helper.js";

const EMAIL_HISTORY_LIMIT = 20;

function ClientEmailHistory({ clientId, onHasEmailHistoryChange }) {
  const [emailHistory, setEmailHistory] = useState([]);
  const [totalLogs, setTotalLogs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchEmailHistoryData = useCallback(async () => {
    if (!clientId) {
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        client_id: clientId,
        offset: 0,
        limit: EMAIL_HISTORY_LIMIT,
      };
      const emailHistoryResponse = await post(
        VYLABS_BASE_URL,
        EMAIL_HISTORY_CLIENT,
        payload,
      );
      const emailLogs = Array.isArray(emailHistoryResponse?.email_logs)
        ? emailHistoryResponse.email_logs
        : [];

      setEmailHistory(emailLogs);
      setTotalLogs(
        typeof emailHistoryResponse?.total_logs === "number"
          ? emailHistoryResponse.total_logs
          : emailLogs.length,
      );
      onHasEmailHistoryChange?.(emailLogs.length > 0);
    } catch (error) {
      console.error("Error fetching client email history:", error);
      setEmailHistory([]);
      setTotalLogs(0);
      onHasEmailHistoryChange?.(false);
    } finally {
      setIsLoading(false);
    }
  }, [clientId, onHasEmailHistoryChange]);

  useEffect(() => {
    fetchEmailHistoryData();
  }, [fetchEmailHistoryData]);

  return (
    <EmailsHistory
      emailHistory={emailHistory}
      totalLogs={totalLogs}
      isLoading={isLoading}
      entityLabel="client"
      mailIcon={mailIcon}
      defaultVariant="client"
    />
  );
}

export default ClientEmailHistory;
